unable to read source [project]/packages/core/src/runtime/utils/hashSequence.ts